var React = require('react');

function ShieldCircle (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(.01 .627)","fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"fill":"#F5D03B","cx":"28.99","cy":"28.373","r":"28","key":0}),React.createElement("path",{"d":"M28.99 41.706s10.666-5.333 10.666-13.333V19.04l-10.666-4-10.667 4v9.333c0 8 10.667 13.333 10.667 13.333z","fill":"#FFF","key":1})]));
}

ShieldCircle.defaultProps = {"className":"shield-circle","viewBox":"0 0 58 58"};

module.exports = ShieldCircle;

ShieldCircle.default = ShieldCircle;
